<template>
  <div>
    <div class="tab-wrap tabset">
      <input type="radio" id="tab1" name="hometabs" class="tab" checked />
      <label for="tab1">Popular</label>
      <input type="radio" id="tab2" name="hometabs" class="tab" />
      <label for="tab2">Previous</label>
      <div class="tab-content" id="popular">
        <!-- Loading state -->
        <div v-if="isLocationLoading" class="center-img loading-state">
          <ion-spinner name="crescent" color="primary"></ion-spinner>
          <p class="loading-text">Finding nearby cafes...</p>
        </div>
        <!-- Cafes list -->
        <div v-else-if="filteredCoffeeShops.length" id="result">
          <div :class="{ hidden: isChristmas }">
            <ion-card
              class="cafelist"
              v-for="cafe in filteredCoffeeShops"
              :key="cafe.id"
            >
              <a :href="'/cafemenu?id=' + cafe.uuid">
                <div class="img-container">
                  <img v-bind:src="cafe.shopImgUrl" class="cafelist-img" />
                </div>
              </a>
              <h2 class="h2-banner">{{ cafe.shopName }}</h2>
              <div class="cafe-info-line status-row">
                <span v-if="cafe.isOpen" class="status-badge open">
                  Open Now
                </span>
                <span v-else class="status-badge closed">Closed</span>
              </div>
              <div class="cafe-info-line">
                <ion-icon
                  src="assets/icon/distance.svg"
                  class="banner-icon"
                  color="primary"
                >
                </ion-icon>
                <span class="cafeinfo-txt">{{
                  cafe.distance ? cafe.distance : cafe.address
                }}</span>
              </div>
              <div class="cafe-info-line">
                <ion-icon
                  src="assets/icon/time-outline.svg"
                  class="banner-icon"
                >
                </ion-icon>
                <span class="cafeinfo-txt">{{
                  getFormattedHours(cafe.businessHours)
                }}</span>
              </div>
              <span class="address-hide" id="destinationSpan">{{
                cafe.address
              }}</span>
            </ion-card>
          </div>
        </div>
        <!-- No results -->
        <div v-else class="center-img">
          <img src="assets/icon/empty-message.png" />
          <h1 class="no-result">No cafes found nearby</h1>
        </div>
      </div>
      <div class="tab-content" id="previous">
        <!-- Loading state -->
        <div v-if="isLocationLoading" class="center-img loading-state">
          <ion-spinner name="crescent" color="primary"></ion-spinner>
          <p class="loading-text">Finding nearby cafes...</p>
        </div>
        <!-- Cafes list -->
        <div v-else-if="filteredCoffeeShops.length" id="result">
          <div :class="{ hidden: isChristmas }">
            <ion-card
              class="cafelist"
              v-for="cafe in filteredCoffeeShops"
              :key="cafe.id"
            >
              <a :href="'/cafemenu?id=' + cafe.uuid">
                <div class="img-container">
                  <img v-bind:src="cafe.shopImgUrl" class="cafelist-img" />
                </div>
              </a>
              <h2 class="h2-banner">{{ cafe.shopName }}</h2>
              <div class="cafe-info-line status-row">
                <span v-if="cafe.isOpen" class="status-badge open">
                  Open Now
                </span>
                <span v-else class="status-badge closed">Closed</span>
              </div>
              <div class="cafe-info-line">
                <ion-icon
                  src="assets/icon/distance.svg"
                  class="banner-icon"
                  color="primary"
                >
                </ion-icon>
                <span class="cafeinfo-txt">{{
                  cafe.distance ? cafe.distance : cafe.address
                }}</span>
              </div>
              <div class="cafe-info-line">
                <ion-icon
                  src="assets/icon/time-outline.svg"
                  class="banner-icon"
                >
                </ion-icon>
                <span class="cafeinfo-txt">{{
                  getFormattedHours(cafe.businessHours)
                }}</span>
              </div>
              <span class="address-hide" id="destinationSpan">{{
                cafe.address
              }}</span>
            </ion-card>
          </div>
        </div>
        <!-- No results -->
        <div v-else class="center-img">
          <img src="assets/icon/empty-message.png" />
          <h1 class="no-result">No cafes found nearby</h1>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import {
  IonIcon,
  IonRow,
  IonCol,
  IonButton,
  IonButtons,
  IonCard,
  IonSpinner,
} from "@ionic/vue";
import { Geolocation } from "@capacitor/geolocation";
import { formatBusinessHours } from "@/utils/businessHours";
import { distanceCache } from "@/utils/distanceCache";

export default defineComponent({
  props: {
    coffeeShops: Object,
    faveCoffeeShops: Object,
  },
  components: {
    IonIcon,
    IonRow,
    IonCol,
    IonButton,
    IonButtons,
    IonCard,
    IonSpinner,
  },
  data() {
    return {
      duration: "",
      distance: "",
      isChristmas: false,
      userLocation: null,
      // Location status: 'loading' | 'ready' | 'unavailable'
      locationStatus: "loading",
      // Track pending distance calculations
      pendingDistanceCalcs: 0,
    };
  },
  created() {
    this.checkIfChristmas();
  },
  mounted: function () {
    this.setFocus(); // Call setFocus method

    // Get user location (will calculate distances when data is ready)
    this.getUserLocation();
  },
  watch: {
    coffeeShops: {
      async handler(newShops) {
        console.log(
          "[watch coffeeShops] Data changed, length:",
          newShops.length
        );
        if (newShops.length && this.userLocation) {
          console.log(
            "[watch coffeeShops] Recalculating distances for coffeeShops"
          );
          await this.calculateDistances(this.userLocation, newShops);
        }
      },
    },
    faveCoffeeShops: {
      async handler(newShops) {
        console.log(
          "[watch faveCoffeeShops] Data changed, length:",
          newShops.length
        );
        if (newShops.length && this.userLocation) {
          console.log(
            "[watch faveCoffeeShops] Recalculating distances for favorites"
          );
          await this.calculateDistances(this.userLocation, newShops);
        }
      },
    },
  },
  computed: {
    isLoggedIn() {
      const token = localStorage.getItem("token");
      return token !== null && token !== "null" && token !== "";
    },
    isLocationLoading() {
      return this.locationStatus === "loading";
    },
    filteredCoffeeShops() {
      console.log(
        "[filteredCoffeeShops] Total cafes:",
        this.coffeeShops.length,
        "locationStatus:",
        this.locationStatus
      );

      // If location is still loading, return empty to show loading spinner
      if (this.locationStatus === "loading") {
        console.log("[filteredCoffeeShops] Location loading, returning empty");
        return [];
      }

      // If location is unavailable, show all cafes without distance filtering
      if (this.locationStatus === "unavailable") {
        console.log(
          "[filteredCoffeeShops] Location unavailable, showing all cafes"
        );
        return this.coffeeShops;
      }

      // Location is ready - filter by distance
      return this.coffeeShops.filter((cafe) => {
        // If no distance calculated (shouldn't happen in ready state, but safety check)
        if (!cafe.distance) {
          console.log(
            `[filteredCoffeeShops] Including ${cafe.shopName} - no distance data`
          );
          return true;
        }

        // Parse distance to kilometers (handles both "m" and "km")
        const distanceInKm = this.parseDistanceToKm(cafe.distance);

        // Include cafes only if distance is less than 30km
        const included = distanceInKm < 30;
        console.log(
          `[filteredCoffeeShops] ${cafe.shopName} - ${
            included ? "INCLUDED" : "EXCLUDED"
          } (${distanceInKm.toFixed(2)} km)`
        );
        return included;
      });
    },
  },
  methods: {
    /**
     * Parse distance string and convert to kilometers
     * @param {string} distanceStr - Distance string like "49 m" or "5.2 km"
     * @returns {number} Distance in kilometers
     */
    parseDistanceToKm(distanceStr) {
      if (!distanceStr) return 0;

      const distanceString = distanceStr.toString().toLowerCase();

      // Extract numeric value
      const numericValue = parseFloat(distanceString.replace(/[^\d.]/g, ""));

      if (isNaN(numericValue)) return 0;

      // Check if it's in meters or kilometers
      if (distanceString.includes("m") && !distanceString.includes("km")) {
        // It's in meters, convert to kilometers
        return numericValue / 1000;
      }

      // It's already in kilometers
      return numericValue;
    },
    setFocus: function () {
      window.addEventListener("load", function () {
        document.getElementById("tab1").focus();
      });
    },
    checkIfChristmas() {
      const today = new Date();
      const month = today.getMonth(); // Months are 0-indexed, 11 is December
      const date = today.getDate();
      this.isChristmas = month === 11 && date === 25;
    },
    getFormattedHours(businessHours) {
      return formatBusinessHours(businessHours);
    },
    async getUserLocation() {
      console.log("[getUserLocation] Starting geolocation request");
      this.locationStatus = "loading";

      // Check if Google Maps API is loaded
      // eslint-disable-next-line no-undef
      if (typeof google === "undefined" || !google.maps) {
        console.error(
          "[getUserLocation] Google Maps API not loaded - distances will not be calculated"
        );
        this.locationStatus = "unavailable";
        return;
      }

      console.log(
        "[getUserLocation] Google Maps API is loaded, checking permissions..."
      );

      try {
        // Check current permission status
        const permStatus = await Geolocation.checkPermissions();
        console.log("[getUserLocation] Permission status:", permStatus);

        // Request permission if not granted
        if (permStatus.location !== "granted") {
          console.log("[getUserLocation] Requesting location permission...");
          const requestResult = await Geolocation.requestPermissions();
          console.log(
            "[getUserLocation] Permission request result:",
            requestResult
          );

          if (requestResult.location !== "granted") {
            console.warn(
              "[getUserLocation] Location permission denied - showing all cafes"
            );
            this.locationStatus = "unavailable";
            return;
          }
        }

        console.log(
          "[getUserLocation] Permission granted, getting position..."
        );

        // Get current position using Capacitor Geolocation
        const position = await Geolocation.getCurrentPosition({
          enableHighAccuracy: false,
          timeout: 15000,
          maximumAge: 300000, // 5 minutes cache
        });

        console.log("[getUserLocation] Position obtained:", {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
        });

        // eslint-disable-next-line no-undef
        this.userLocation = new google.maps.LatLng(
          position.coords.latitude,
          position.coords.longitude
        );

        console.log(
          "✓ Location obtained successfully, starting distance calculations"
        );

        // Call distance calculation for each tab's cafes (if data already loaded)
        if (this.coffeeShops.length) {
          console.log(
            `[getUserLocation] Calculating distances for ${this.coffeeShops.length} coffeeShops`
          );
          await this.calculateDistances(this.userLocation, this.coffeeShops);
        } else {
          // No cafes yet, mark as ready (watcher will handle when data arrives)
          this.locationStatus = "ready";
        }
        if (this.faveCoffeeShops.length) {
          console.log(
            `[getUserLocation] Calculating distances for ${this.faveCoffeeShops.length} faveCoffeeShops`
          );
          await this.calculateDistances(
            this.userLocation,
            this.faveCoffeeShops
          );
        }
      } catch (error) {
        console.error("[getUserLocation] Error:", error.message || error);
        console.error(
          "[getUserLocation] iOS Simulator: Set location via Features > Location > Custom Location"
        );
        this.locationStatus = "unavailable";
      }
    },
    async calculateDistances(userLocation, cafes) {
      if (!cafes.length) {
        this.locationStatus = "ready";
        return;
      }

      const promises = cafes.map((cafe) => {
        return new Promise((resolve) => {
          // Use cafe UUID or ID as cache key
          const cafeId = cafe.uuid || cafe.cafeId || cafe.id;

          // Check cache first
          const cached = distanceCache.get(cafeId, userLocation);
          if (cached) {
            // Use cached data
            cafe.distance = cached.distance;
            cafe.duration = cached.duration;
            resolve();
            return;
          }

          // Cache miss - calculate distance via API
          const destination = cafe.address;

          this.initMap(userLocation, destination, (err, distance, duration) => {
            if (!err) {
              cafe.distance = distance;
              cafe.duration = duration;
              // Store in cache
              distanceCache.set(cafeId, userLocation, distance, duration);
            } else {
              cafe.distance = null;
              cafe.duration = null;
            }
            resolve();
          });
        });
      });

      await Promise.all(promises);
      console.log("[calculateDistances] All distances calculated");
      this.locationStatus = "ready";
    },
    initMap(userLocation, destination, callback) {
      // eslint-disable-next-line no-undef
      const service = new google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        {
          origins: [userLocation],
          destinations: [destination],
          travelMode: "DRIVING",
          // eslint-disable-next-line no-undef
          unitSystem: google.maps.UnitSystem.METRIC,
          avoidHighways: false,
          avoidTolls: false,
        },
        (response, status) => {
          if (status === "OK") {
            const distance = response.rows[0].elements[0].distance.text;
            const duration = response.rows[0].elements[0].duration.text;
            callback(null, distance, duration);
          } else {
            console.error(`Distance calculation failed: ${status}`);
            callback(new Error(`Status: ${status}`), null, null);
          }
        }
      );
    },
  },
});
</script>
<style scoped>
.h1-banner {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  color: #1b1b1b;
  margin: 15px 0px 15px 15px;
}
.link-banner {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: #0057ff;
  float: right;
  padding-right: 15px;
  padding-top: 3px;
}
.h2-banner {
  font-family: "Gilroy";
  font-style: normal;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  margin-top: 0px;
  margin-bottom: 5px;
  text-align: left;
}
a.link-banner {
  text-decoration: none;
}
.rating-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 132.6%;
  letter-spacing: 0.02em;
  color: #1b1b1b;
}
.cafeinfo-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 132.6%;
  letter-spacing: 0.02em;
  color: #828282;
}
.banner-icon {
  vertical-align: middle;
  padding-right: 5px;
  width: 11px;
}
.dotsep-icon {
  vertical-align: middle;
  width: 3px;
  height: 3px;
  padding-right: 10px;
  padding-left: 10px;
}
.cafelist {
  border-radius: 2px;
  box-shadow: none;
}
.cafelist-img {
  border: none;
  box-shadow: none;
  border-radius: 8px;
  width: auto;
  height: 128px;
  object-fit: cover;
  margin-bottom: 10px;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
  /* Your styles for iPads in portrait mode */
  .cafelist-img {
    border: none;
    box-shadow: none;
    border-radius: 8px;
    width: auto;
    height: 380px;
    object-fit: cover;
    margin-bottom: 10px;
  }
}

/* For iPads in landscape mode */
@media only screen and (min-device-width: 768px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 1) and (orientation: landscape) {
  /* Your styles for iPads in landscape mode */
  .cafelist-img {
    border: none;
    box-shadow: none;
    border-radius: 8px;
    width: auto;
    height: 380px;
    object-fit: cover;
    margin-bottom: 10px;
  }
}

/* Common styles for iPads */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  /* Your common styles for iPads */
  .cafelist-img {
    border: none;
    box-shadow: none;
    border-radius: 8px;
    width: auto;
    height: 380px;
    object-fit: cover;
    margin-bottom: 10px;
  }
}
ion-card {
  margin-top: 5px;
  margin-bottom: 10px;
}
div.img-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.img-container img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
}
/*
 Tab new start
*/
.tab-wrap {
  -webkit-transition: 0.3s box-shadow ease;
  transition: 0.3s box-shadow ease;
  border-radius: 6px;
  max-width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  position: relative;
  list-style: none;
  background-color: #fff;
  margin-bottom: 0;
  min-height: 0;
}
.tab {
  display: none;
}
.tab:checked:nth-of-type(1) ~ .tab-content:nth-of-type(1) {
  display: block;
  -webkit-animation: fadeIn 0.3s ease-in;
  animation: fadeIn 0.3s ease-in;
}
.tab:checked:nth-of-type(2) ~ .tab-content:nth-of-type(2) {
  display: block;
  -webkit-animation: fadeIn 0.3s ease-in;
  animation: fadeIn 0.3s ease-in;
}
.tab:checked:nth-of-type(3) ~ .tab-content:nth-of-type(3) {
  display: block;
  -webkit-animation: fadeIn 0.3s ease-in;
  animation: fadeIn 0.3s ease-in;
}
.tab:checked:nth-of-type(4) ~ .tab-content:nth-of-type(4) {
  display: block;
  -webkit-animation: fadeIn 0.3s ease-in;
  animation: fadeIn 0.3s ease-in;
}
.tab:checked:nth-of-type(5) ~ .tab-content:nth-of-type(5) {
  display: block;
  -webkit-animation: fadeIn 0.3s ease-in;
  animation: fadeIn 0.3s ease-in;
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.tab:checked + label {
  box-shadow: 0 -1px 0 #fff inset;
  cursor: default;
  color: #ffffff;
  background: #f87e63;
}
.tab:checked + label:hover {
  box-shadow: 0 -1px 0 #fff inset;
  color: #ffffff;
  background: #f87e63;
}
.tab + label {
  box-shadow: 0 -1px 0 #eee inset;
  border-radius: 8px;
  cursor: pointer;
  display: block;
  text-decoration: none;
  display: inline-block;
  padding: 10px 10px 10px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  color: #1b1b1b;
  margin: 10px 10px 10px 10px;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  -webkit-box-flex: 3;
  -webkit-flex-grow: 3;
  -ms-flex-positive: 3;
  flex-grow: 3;
  text-align: center;
  background-color: #f2f2f2;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
  -webkit-transition: 0.3s background-color ease, 0.3s box-shadow ease;
  transition: 0.3s background-color ease, 0.3s box-shadow ease;
  height: 40px;
  box-sizing: border-box;
}
.tab + label:hover {
  color: #ffffff;
  background: #f87e63;
}
.tab-content {
  background-color: transparent;
  width: 100%;
  display: none;
  border-radius: 6px;
  padding-top: 10px;
}
.center-img {
  text-align: center;
  display: block !important;
  padding: 40px 20px;
  min-height: 300px;
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.center-img img {
  max-width: 250px;
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}
.no-result {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #1b1b1b;
  margin-top: 0px;
  margin-bottom: 5px;
  display: block;
}
.address-hide {
  color: #ffffff;
  font-size: 1px;
}
.op-hours {
  display: block;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0.02em;
  color: #828282;
  margin-top: 5px;
}
.status-badge {
  display: inline-block;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-top: 5px;
  margin-left: 5px;
}
.status-badge.open {
  background-color: #d4edda;
  color: #155724;
}
.status-badge.closed {
  background-color: #f8d7da;
  color: #721c24;
}
.cafe-info-line {
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
  flex-wrap: nowrap;
}
.cafe-info-line .cafeinfo-txt {
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.address-text {
  flex: 1;
  margin-right: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hidden {
  display: none;
}
.loading-state {
  min-height: 200px;
}
.loading-state ion-spinner {
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
}
.loading-text {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #828282;
  margin: 0;
}
</style>
